import * as React from "react";
import Flex from "antd/es/flex";
import Button from "antd/es/button";
import Image from "antd/es/image";
import Title from "antd/es/typography/Title";
import { ExchangeToken } from "./types";

export interface TokenSelectProps {
    onSelect: (token: ExchangeToken) => void;
}

export const TokenSelect: React.FunctionComponent<TokenSelectProps> = (props) => {
    return (
        <Flex align="center" vertical gap="15px" justify="center" className="TokenSelector">
            <Title level={3}>
                Choose token to bridge
            </Title>
            <Button
                onClick={() => props.onSelect("LLD")}
                icon={<Image src={require("../logo-small.png")} width="22px" height="22px" preview={false} />}
                className="LiberlandButton LiberlandButton--bridge"
                size="large"
            >
                Liberland Dollar
            </Button>
            <Button
                onClick={() => props.onSelect("USDT")}
                icon={<Image src={require("../usdt.svg").default} width="22px" height="22px" preview={false} />}
                className="USDTButton"
                size="large"
                disabled
            >
                USDT Coming soon
            </Button>
        </Flex>
    );
};
